class WindowLocation {
  static protocol () {
    return window.location.protocol
  }

  static port () {
    return window.location.port
  }

  static hostname () {
    return window.location.hostname
  }

  static pathname () {
    return window.location.pathname
  }

  static search () {
    return window.location.search
  }

  static subdomain () {
    return window.location.href.split('.')[0].split('/')[2]
  }

  static reload () {
    window.location.reload()
  }

  static replace (url: string) {
    window.location.replace(url)
  }

  static assign (url: string) {
    window.location.assign(url)
  }
}

export default WindowLocation
